/**
 * useSession — returns the current auth session from AuthContext.
 *
 * Split into its own file so react-refresh can fast-reload hooks independently
 * from the AuthProvider component (react-refresh/only-export-components rule).
 *
 * Returns `{ session, user, role, loading }` — `role` is `app_metadata.role`
 * with a fallback to `'authenticated'`. Phase 10b wired the real Supabase
 * onAuthStateChange listener; the historical "stub returning loading:false"
 * note is gone — the AuthProvider's getSession + onAuthStateChange combo is
 * the source of truth.
 */

import { useContext } from 'react';
import { AuthContext } from './auth-context';
import type { AuthContextValue } from './auth-context';

export function useSession(): AuthContextValue {
  return useContext(AuthContext);
}
